module.exports = __webpack_public_path__ + "static/media/PinkTick.c353877f.svg";